"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 查找值配置模块
var _default = exports.default = {
  getLookupList: function getLookupList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/lookup/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getLookupDetail: function getLookupDetail(id) {
    return (0, _request.default)({
      url: '/protected/lookup/query/' + id,
      method: 'get'
    });
  },
  getLookupTypeCodeDetail: function getLookupTypeCodeDetail(typeCode) {
    return (0, _request.default)({
      url: '/protected/lookup/values/' + typeCode,
      method: 'get'
    });
  },
  getLookupMultiTypeCodeDetail: function getLookupMultiTypeCodeDetail(data) {
    return (0, _request.default)({
      url: '/protected/lookup/multi_values',
      method: 'post',
      data: data
    });
  },
  saveLookup: function saveLookup(data) {
    return (0, _request.default)({
      url: '/protected/lookup/save',
      method: 'post',
      data: data
    });
  },
  deleteLookup: function deleteLookup(data) {
    return (0, _request.default)({
      url: '/protected/lookup/delete',
      method: 'post',
      data: data
    });
  }
};